<div class="main-container">
  <div class="message-container">
    {{ 'User.Message.ProceedDeleteAccount' | translate }}
  </div>

  <div class="buttons-container">
    <div class="button-slot">
      <button mat-raised-button (click)="onCancel()">
        {{ 'Main.Button.Cancel' | translate }}
      </button>
    </div>
    <div class="button-slot">
      <button mat-raised-button
        *ngIf="!operationInProgress"
        type="submit" (click)="onDisableAccount()">
        {{ 'Menu.Elimina Account' | translate }}
      </button>

      <span *ngIf="operationInProgress">
        <mat-spinner [diameter]="40"></mat-spinner>
      </span>
    </div>
  </div>
</div>